import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationType } from '../../../shared/constants/types';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
    private defaultNotification: { type: NotificationType, message: string } = { type: null, message: '' };
    private notificationSubject = new BehaviorSubject<{ type: NotificationType, message: string }>(this.defaultNotification);

    constructor() { }

    getNotificationSubject() {
      return this.notificationSubject.asObservable();
    }

    showSuccess(message: string) {
      this.notificationSubject.next({ type: 'success', message });
    }

    showError(message: string) {
      this.notificationSubject.next({ type: 'error', message });
    }

    showNotification(message: string) {
      this.notificationSubject.next({ type: 'notification', message });
    }
}
